<template>
  <div class="spinner"></div>
</template>

<script>
export default {
  name: "SpinerComponent",
};
</script>

<style lang="scss" scoped>
.spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  background: linear-gradient(0deg, rgba(0, 132, 255, 0.2) 33%, #008cff 100%);
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.spinner::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ffffff;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
